import { Skeleton } from '@/components/ui/skeleton'

interface AdvisorMessagesSkeletonProps {
  isProfessor: boolean
}

const AdvisorMessagesSkeleton: React.FC<AdvisorMessagesSkeletonProps> = ({
  isProfessor,
}) => {
  return (
    <>
      {/* Professor Message */}
      <div
        className={`flex mb-4 ${isProfessor ? 'justify-end' : 'justify-start'}`}
      >
        <div className='max-w-[80%] p-4 rounded-[20px] bg-[#e2ece4]'>
          <div className='flex items-center gap-3 mb-2'>
            <Skeleton className='w-8 h-8 rounded-full' />
            <div className='flex items-center'>
              <div className='flex flex-col mr-2'>
                <Skeleton className='h-4 w-32' />
              </div>
              <Skeleton className='h-5 w-16 rounded-md ml-2' />
            </div>
          </div>
          <div className='space-y-2'>
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-4/5' />
            <Skeleton className='h-4 w-3/4' />
          </div>
        </div>
      </div>

      {/* Player Message */}
      <div
        className={`flex mb-4 ${!isProfessor ? 'justify-end' : 'justify-start'}`}
      >
        <div className='max-w-[80%] p-4 rounded-[20px] bg-[#f7d4e2]'>
          <div className='flex items-center gap-3 mb-2'>
            <Skeleton className='w-8 h-8 rounded-full' />
            <div className='flex items-center'>
              <div className='flex flex-col mr-2'>
                <Skeleton className='h-4 w-28' />
                <Skeleton className='h-3 w-20 mt-1' />
              </div>
              <Skeleton className='h-5 w-12 rounded-md ml-2' />
            </div>
          </div>
          <div className='space-y-2'>
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-2/3' />
          </div>
        </div>
      </div>

      {/* Chatbot Message */}
      <div className='flex mb-4 justify-start'>
        <div className='max-w-[80%] p-4 rounded-[20px] bg-[#E6ECF1]'>
          <div className='flex items-center gap-3 mb-2'>
            <Skeleton className='w-8 h-8 rounded-full' />
            <div className='flex items-center'>
              <div className='flex flex-col mr-2'>
                <Skeleton className='h-4 w-24' />
              </div>
            </div>
          </div>
          <div className='space-y-2'>
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-5/6' />
            <Skeleton className='h-4 w-4/5' />
            <Skeleton className='h-4 w-1/2' />
          </div>
        </div>
      </div>
    </>
  )
}

export default AdvisorMessagesSkeleton
